/* @ngInject */
function FormatsController ($rootScope, $scope, $state, $timeout, $translate, UdsModalService, FormatService, AdminService, UserService) {
  const getCreateFormatController = () => import('../../dialogs/create-format/create-format.controller')
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  $scope.disableUsersFilter = true
  $scope.loading = false
  $scope.formatsTotal = 0
  $scope.top = 10
  $scope.skip = 0
  $scope.isAsc = true
  $scope.order = 'ASC'
  $scope.sort = 'author'
  $scope.iconCreatedAt = 'chevron-down'
  $scope.iconAuthor = 'chevron-down'
  $scope.formats = []
  $scope.filteredUsers = []
  $scope.usersOptions = {
    top: 10,
    skip: 0,
    hasMoreOptions: false
  }
  $scope.types = {
    digital: $translate.instant('formatsTable.selectOptions.digital').toUpperCase(),
    printable: $translate.instant('formatsTable.selectOptions.printable').toUpperCase()
  }
  $scope.pageTitle = ''

  const api = {
    _getFormats,
    _setIcon,
    _getUsers,
    _handleSuccessGetUsers,
    _getUserProfileImage,
    _hasMoreResults
  }

  this.getApi = () => api

  function activate () {
    $scope.loading = true
    $rootScope.getUserCompany().then((userCompany) => {
      $scope.createdByFilter = [
        { label: 'Deskfy', value: false },
        { label: userCompany.formattedName, value: true }
      ]
      api._getUsers({ skip: $scope.usersOptions.skip, top: $scope.usersOptions.top })
      api._getFormats({ skip: $scope.skip, top: $scope.top, sort: 'createdAt', order: 'ASC' })
    })
  }

  activate()

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('formats')
  })

  $scope.onChangeSelectCreatedByFilter = (event) => {
    $scope.customerSpecific = event?.detail?.value
    $scope.disableUsersFilter = $scope.customerSpecific
    api._getFormats({
      customerSpecific: $scope.customerSpecific,
      search: $scope.searchedName,
      authorsId: $scope.authorsId,
      skip: $scope.skip,
      top: $scope.top
    })
  }

  $scope.onChangeSelectUserFilter = (event) => {
    const newValue = event?.detail
    $scope.authorsId = newValue.map(user => user.value)
    if (newValue) {
      api._getFormats({
        authorsId: $scope.authorsId,
        skip: $scope.skip,
        top: $scope.top
      })
    }
  }

  $scope.onChangeSearchUsersSelect = (event) => {
    const totalCount = event.detail?.totalCount
    const search = event.detail?.search || ''
    $scope.usersOptions.skip = 0

    if (search === '') {
      api._getUsers({
        skip: $scope.usersOptions.skip,
        top: $scope.usersOptions.top,
        search: $scope.searchedName
      })
    }

    api._getUsers({ totalCount, search })
  }

  $scope.onInfiniteUsers = (event) => {
    const totalCount = event.detail?.totalCount
    $scope.formatsOptions.skip = totalCount

    api._getUsers({ skip: $scope.formatsOptions.skip, top: $scope.formatsOptions.top })
  }

  function _getUsers (queryParams) {
    const { top, skip, search } = queryParams
    AdminService.getUsers(top, skip, { search }).then((response) => {
      api._handleSuccessGetUsers(response)
    })
  }

  function _handleSuccessGetUsers (response) {
    const users = response.d.results
    const usersRes = users.map(user => ({
      label: user.name,
      value: user.id
    }))

    $scope.filteredUsers = [...usersRes]
    $scope.usersOptions.hasMoreOptions = api._hasMoreResults(usersRes.length, response.d.__count)
  }

  function _hasMoreResults (totalCount, responseLength) {
    const usersCount = responseLength
    if (!responseLength) {
      return false
    }
    return usersCount > totalCount
  }

  function _getUserProfileImage (id, createdAt = '') {
    return UserService.getUserProfileImage(id, createdAt)
  }

  function _getFormats (queryParams) {
    FormatService.getFormats(queryParams).then((response) => {
      $scope.formats = response.rows
      $scope.formatsTotal = response.count
      $scope.loading = false
    })
  }

  function _setIcon (icon) {
    if ($scope.sort === 'createdAt') {
      $scope.iconCreatedAt = icon
    } else if ($scope.sort === 'author') {
      $scope.iconAuthor = icon
    }
  }

  $scope.toggle = function (flag) {
    $scope.sort = flag
    $scope.isAsc = !$scope.isAsc

    if (!$scope.isAsc) {
      $scope.order = 'DESC'
      api._setIcon('chevron-up')
      api._getFormats({
        customerSpecific: $scope.customerSpecific,
        sort: $scope.sort,
        order: $scope.order,
        skip: $scope.skip,
        top: $scope.top
      })
    } else {
      $scope.order = 'ASC'
      api._setIcon('chevron-down')
      api._getFormats({
        customerSpecific: $scope.customerSpecific,
        sort: $scope.sort,
        order: $scope.order,
        skip: $scope.skip,
        top: $scope.top
      })
    }
  }

  $scope.getPaginationPage = function (ev) {
    $scope.skip = (ev.detail.currentPage - 1) * $scope.top
    api._getFormats({
      customerSpecific: $scope.customerSpecific,
      sort: $scope.sort,
      order: $scope.order,
      skip: $scope.skip,
      top: $scope.top
    })
  }

  $scope.formatsSearch = (inputEvent) => {
    $scope.searchedName = inputEvent?.detail?.value
    if ($scope.searchedName === '') {
      api._getFormats({
        customerSpecific: $scope.customerSpecific,
        skip: $scope.skip,
        top: $scope.top
      })
    }
    api._getFormats({
      customerSpecific: $scope.customerSpecific,
      search: $scope.searchedName,
      sort: $scope.sort,
      order: $scope.order,
      skip: $scope.skip,
      top: $scope.top
    })
  }

  $scope.openCreateFormatModal = async function (data) {
    const { flag, formatId, name, type, templates, formats } = data
    const createFormatData = { flag, formatId, name, type, templates, formats }

    const { CreateFormatController } = await getCreateFormatController()
    const createFormat = UdsModalService.createModal({
      controller: CreateFormatController,
      modalName: 'createFormat',
      data: createFormatData,
      onClose: (returnData) => {
        if (returnData?.success) {
          api._getFormats({
            customerSpecific: $scope.customerSpecific,
            search: $scope.searchedName,
            sort: $scope.sort,
            order: $scope.order,
            skip: $scope.skip,
            top: $scope.top
          })
        }
      },
      onOpen: () => {}
    })

    createFormat.open()
  }

  $scope.headerNavigation = {
    buttons: [{
      type: 'button',
      btnType: 'primary',
      icon: 'plus',
      label: $translate.instant('formatsTable.button'),
      onClick: $scope.openCreateFormatModal.bind(null, { flag: 'create' })
    }]
  }
}

export { FormatsController }
